import { useEffect } from 'react'
import styles from './Gear.module.css'
import homeStyles from './Home.module.css'
import Layout from '../components/Layout'
import globalStyles from '../styles/global.module.css'

const Gear = () => {
  useEffect(() => {
    console.log('Gear component mounted')
    // Load the script when component mounts
    const script = document.createElement('script')
    script.src = 'https://lighterpack.com/e/4e5cjt'
    script.async = true
    document.body.appendChild(script)

    return () => {
      // Clean up on unmount
      document.body.removeChild(script)
      
    }
  }, [])

  return (
    <Layout>
      <div className={homeStyles.twoColumnLayout} style={{ marginTop: '20px' }}>
        <div className={homeStyles.leftColumn}>
          <div className={styles.gearContainer}>
            <div id="4e5cjt"></div>
          </div>
        </div>
        <div className={homeStyles.rightColumn}>
          <div className={globalStyles.card} style={{ paddingTop: '1em' }}>
            <h2 style={{ marginTop: '.5em', marginBottom: '0em' }}>Gear</h2>
            <p>This is a listing of all of the gear I am carrying on my back. It does not include any consumables (such as food, water, or fuel) or worn clothing.</p>
            <div className={styles.gearImageContainer}>
              <img 
                src="/images/gear.png" 
                alt="PCT Gear" 
                className={styles.gearImage} 
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Gear 